import React from 'react';
import ProtectedLink from '../ProtectedLink';
import { useAuthStore } from '../../store/authStore';
import { useAuthModalStore } from '../../store/authModalStore';
import '../../styles/home/JoinCTASection.css';

const JoinCTASection: React.FC = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const openRegister = useAuthModalStore((s) => s.openRegister);

  return (
    <section className="join-cta">
      <div className="join-cta__overlay" />
      <div className="join-cta__content">
        <span className="join-cta__tag">READY TO TRANSFORM YOUR SUPPLY CHAIN?</span>
        <h2 className="join-cta__heading">
          Join the VIN<br />Partner <span className="join-cta__heading--accent">Network</span>
        </h2>
        <p className="join-cta__subtitle">
          Gain access to smarter ordering, reliable delivery, and the full
          intelligence of VIN Pulse OS — everything you need to run a
          tighter, better-stocked retail business.
        </p>
        <div className="join-cta__buttons">
          {isAuthenticated ? (
            <ProtectedLink to="/products" className="join-cta__btn join-cta__btn--primary">
              Explore the Platform
            </ProtectedLink>
          ) : (
            <>
              <button className="join-cta__btn join-cta__btn--primary" onClick={openRegister}>
                Become a VIN Partner
              </button>
              <ProtectedLink to="/products" className="join-cta__btn join-cta__btn--outline">
                Explore the Platform
              </ProtectedLink>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default JoinCTASection;
